<script lang="ts">
// the theme rows and their header share this grid: name, delete
export const THEME_COLUMNS: string = 'minmax(12rem, 1fr) 2rem';
</script>

<script setup lang="ts">
import {nextTick, type PropType, ref} from 'vue';
import {THEME_CHANGE_EMIT, THEME_REMOVE_EMIT} from '@/base/cabConstants';
import {bevestigVerwijderen} from '@/base/utils';
import type {CabTheme} from 'common';
import RowGrid from '@/views/ui/RowGrid.vue';
import IconButton from '@/views/ui/IconButton.vue';
import {Trash2} from 'lucide-vue-next';

const emits = defineEmits([THEME_REMOVE_EMIT, THEME_CHANGE_EMIT]);
const props = defineProps({
    theme: {
        type    : Object as PropType<CabTheme>,
        required: true,
    },
});
defineExpose({
    firstEdit,
});

const theme       = ref<CabTheme>(props.theme);
const nameField   = ref<HTMLInputElement | null>(null);
const nameEditing = ref<boolean>(false);

let isFirstEdit: boolean = false;

//==========================================
function firstEdit() {
    isFirstEdit = true;
    startEditingName();
}

//==========================================;
function startEditingName() {
    nameEditing.value = true;
    nextTick(() => nameField.value!.focus());
}

function stopEditingName() {
    nameEditing.value = false;
    nameField.value!.blur();
    if (isFirstEdit) {
        if (!props.theme.name.trim()) {
            onDelete();
        }
        isFirstEdit = false;
    }
}

//==========================================;
async function onDeleteClick() {
    if (await bevestigVerwijderen(theme.value.name?.trim() ? `Thema "${theme.value.name}"` : 'Dit thema')) {
        onDelete();
    }
}

function onDelete() {
    emits(THEME_REMOVE_EMIT, theme.value);
}

function onChange() {
    emits(THEME_CHANGE_EMIT, theme.value);
}
</script>

<template>
    <RowGrid :columns="THEME_COLUMNS">
        <input
            class="row-input"
            :class="{'row-input-on': nameEditing}"
            type="text"
            ref="nameField"
            v-model="theme.name"
            @input="onChange"
            @click="startEditingName()"
            @focus="startEditingName()"
            @keyup.enter="stopEditingName()"
            @blur="stopEditingName()"
            placeholder="thema naam"
            :title="theme.name"
        />
        <IconButton :icon="Trash2" label="permanent verwijderen" variant="danger" size="sm" data-testid="delete-button" @click="onDeleteClick()"/>
    </RowGrid>
</template>
